// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31JNp","question":"styles_question__pROKX","description":"styles_description__2K02j"};